import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Tooltip from '../../../../../../components/LazyWidgets/Tooltip';
import Card from '../../../../../../components/LazyWidgets/Card';
import { REPORT_TYPES } from '../../../../../actions/constants';
import s from './reviewedFeedbackCard.module.css';
import MLIcon from '../../../../../../components/MLIcon';
import { getReviewedByStudentColumn } from '../../../../../../components/SkillsFeedbackTable/componentFunctions';
import { getConfigObject } from '../../../../../util/config';

import PaginatedTable from '../../../../../../components/PaginatedTable/PaginatedTable';

class ReviewedFeedbackCard extends Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    data: PropTypes.array,
    loading: PropTypes.bool,
    onTabChange: PropTypes.func,
    studentsNotViewedFeedback: PropTypes.number,
  };

  static defaultProps = {
    id: '',
    className: '',
    data: [],
    loading: true,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!_.isEqual(nextProps.data, prevState.dataRaw)) {
      return ({
        data: ReviewedFeedbackCard.styleData(nextProps.data),
        dataRaw: nextProps.data,
      });
    }
    return null;
  }

  static styleData(data) {
    return data.map((item) => {
      item.className = item.reviewed === 0 ? 'zeroStyle' : 'styledRow';
      return item;
    });
  }

  constructor(props) {
    super(props);
    const { data } = props;
    const styledData = ReviewedFeedbackCard.styleData(data);
    const tableStyle = [
      {
        row: 'styledRow',
        cells: [
          { accessor: 'feedback', alignment: 'left' },
          { accessor: 'commentsMade', alignment: 'right' },
          { accessor: 'reviewed', alignment: 'right' },
        ],
      },
    ];
    const handleClickFeedback = (feedbackId) => {
      this.props.onTabChange(`reports/type/skills-feedback-summary/${feedbackId}`);
    };

    const { DASHBOARD_ENABLED_SKILLS_REVIEWED_FEEBACK_SUMMARY } = getConfigObject();

    const tableColumns = [
      {
        accessor: 'name',
        Header: 'Feedback',
        cell: (item) => {
          if (DASHBOARD_ENABLED_SKILLS_REVIEWED_FEEBACK_SUMMARY) {
            return (<a role="button" tabIndex="0" onClick={() => handleClickFeedback(item.id)}>
              <Tooltip trigger={<span>{item.name}</span>} content={item.name} on="hover" />
            </a>);
          }
          return <Tooltip trigger={<span>{item.name}</span>} content={item.name} on="hover" />;
        },
        alignment: 'right',
      },
      {
        accessor: 'commentsMade',
        Header: 'Instructor Comments',
        cell: item => item.commentsMade,
        alignment: 'right',
      },
      {
        accessor: 'reviewed',
        Header: 'Reviewed by Student',
        cell: item => (getReviewedByStudentColumn(item, 'reviewed', 'commentsMade')),
      },
    ];

    this.state = {
      dataRaw: this.props.data,
      tableStyle,
      tableColumns,
      data: styledData,
    };
  }

  getNullStateMessage() {
    return (
      <div className={s.nullCard}>
        <h1 className={s.mainMessage}>You haven&#39;t given students any feedback.</h1>
        <div className={s.bottomText}>As you provide feedback, you can see whether students are reviewing it and how frequently.</div>
      </div>
    );
  }

  miniTableColumns() {
    const avg = _.find(this.state.tableColumns, ['accessor', 'reviewed']);
    const mini = [...this.state.tableColumns];
    const indexToRemove = mini.indexOf(avg);
    mini.splice(indexToRemove, 1);
    mini.splice(1, 0, avg);
    return mini;
  }

  render() {
    const { DASHBOARD_ENABLED_SKILLS_REVIEWED_FEEBACK_SUMMARY } = getConfigObject();
    const { data, loading, studentsNotViewedFeedback } = this.props;
    const { tableStyle, tableColumns } = this.state;
    const modalContent = (
      <div>
        <p>The first column in this report - “Instructor Comments” - counts the number of times you have left feedback tied to a draft goal or editing mark across all drafts over the span of the course.<br /></p>
        <p>The second column - “Reviewed by Student” - counts how many of those comments have been viewed at least once by the student to whom you gave the feedback.<br /></p>
        <p>Regardless of how many times a student repeatedly views your comment connected with a given draft goal or editing mark, the total count of feedback that has been reviewed will not exceed the total count of times feedback was given.</p>
      </div>
    );

    const handleFeedbackClick = () => {
      this.props.onTabChange(`reports/type/${REPORT_TYPES.skillsNotReviewedFeedbackSummary}`);
    };

    const notSeenFeedbackText = () => {
      const iconSize = '24px';
      const notSeenFeedbackNumber = !studentsNotViewedFeedback ? 0 : studentsNotViewedFeedback;

      if (DASHBOARD_ENABLED_SKILLS_REVIEWED_FEEBACK_SUMMARY && data && data.length > 0 && notSeenFeedbackNumber > 0) {
        return (
          <a role="button" className={s.readZeroFeedback} onClick={handleFeedbackClick} tabIndex="0">
            {notSeenFeedbackNumber} student{notSeenFeedbackNumber > 1 ? 's have' : ' has'} reviewed 0 feedback
            <MLIcon
              className={s.chevron}
              type="chevron_right"
              role="presentation"
              width={iconSize}
              height={iconSize}
            />
          </a>
        );
      }
      return null;
    };

    return (
      <Card className={s.containerCard}>
        <PaginatedTable
          id="reviewedFeedback"
          className={s.tableCard}
          title="Are students reviewing my feedback?"
          data={data}
          tableStyle={tableStyle}
          tableColumns={tableColumns}
          sortBy="reviewed"
          direction="asc"
          modalContent={modalContent}
          nullState={this.getNullStateMessage()}
          styleFunction={() => 'styledRow'}
          tableMinWidth={200}
          loading={loading}
          collapsible={false}
        />
        {notSeenFeedbackText()}
      </Card>
    );
  }
}

export default ReviewedFeedbackCard;
